module.exports = __webpack_public_path__ + "img/elon.4a8437ee.jpg";